import { SVGProps, Ref, forwardRef } from 'react';

export const PlusBoldFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M13 1c1.886 0 2.828 0 3.414.586S17 3.114 17 5v2h2c1.886 0 2.828 0 3.414.586S23 9.114 23 11v2c0 1.886 0 2.828-.586 3.414S20.886 17 19 17h-2v2c0 1.886 0 2.828-.586 3.414S14.886 23 13 23h-2c-1.886 0-2.828 0-3.414-.586S7 20.886 7 19v-2H5c-1.886 0-2.828 0-3.414-.586S1 14.886 1 13v-2c0-1.886 0-2.828.586-3.414S3.114 7 5 7h2V5c0-1.886 0-2.828.586-3.414S9.114 1 11 1z"
            fill="currentColor"
        />
    </svg>
));
PlusBoldFilledSize24Glyph.displayName = 'PlusBoldFilledSize24Glyph';
